<template>
  <div class="forum-next-prose" @click="openImage" v-html="content.html"></div>
</template>
<script>
import { forumImageContent } from '../models/forumImages';
export default {
  name: 'ForumPostBody', props: { html: { type: String, default: '' } },
  computed: { content() { return forumImageContent(this.html); } },
  methods: {
    openImage(event) {
      const button = event.target.closest('button[data-forum-image]');
      if (!button || !this.$el.contains(button)) return;
      const index = Number(button.getAttribute('data-forum-image'));
      const image = this.content.images[index];
      if (!Number.isInteger(index) || !image) return;
      button.focus({ preventScroll: true }); this.$emit('image', image);
    }
  }
};
</script>
<style lang="scss">
.forum-next-prose .forum-next-image-trigger { display: block; position: relative; max-width: 100%; min-height: 44px; padding: 0; margin: 16px 0; border: 1px solid var(--modern-border); border-radius: 8px; background: var(--modern-bg); color: var(--modern-text); overflow: hidden; cursor: zoom-in; text-align: start; }
.forum-next-prose .forum-next-image-trigger img { margin: 0; }
.forum-next-image-hint { display: block; padding: 6px 10px; color: var(--forum-next-link); font-size: 12px; }
.forum-next-prose .forum-next-image-trigger--linked { padding: 8px 12px; font-size: 13px; }
.forum-next-image-trigger:focus-visible { outline: 2px solid var(--modern-accent); outline-offset: 3px; }
</style>
